module.exports = __webpack_public_path__ + "static/media/logo.6f7b8f92.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/LandingPage/Components/Header/img/logo.PNG
// module id = 32
// module chunks = 0